import React, {Component} from 'react';
import '../../styles/Home.css'
import {Button} from "react-bootstrap";
import 'react-phone-number-input/style.css'
import * as acc from "accounting";
import KoszykService from "../KoszykService";
import Footer from "../../shared/Footer";
import Realizacja from "./Realizacja";
import TopIf from "../../topComponents/if/TopIf";
import DictionaryJS from '../../topComponents/DictionaryJS'
import Link from "react-router-dom/es/Link";
import Zgody from "../../shared/Zgody";
import moment from "moment";
import WyszukiwarkaService from "../../wyszukiwarka/WyszukiwarkaService";
import {NotificationManager} from "react-notifications";

export default class Finalizacja extends Component {

    constructor(props) {
        super(props);

        let email = '';
        let telefon = '';

        if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
            email = JSON.parse(sessionStorage.getItem('loggedIn')).login;
            telefon = JSON.parse(sessionStorage.getItem('loggedIn')).nrTel
        }

        this.state = {
            data: '',
            email: email,
            emailInvalid: false,
            nip: '',
            nipCheck: false,
            nipInvalid: false,
            konfig: '',
            odliczanie: moment(sessionStorage.getItem('koszykTimer')).format('mm:ss'),
            telefon: telefon,
            telefonInvalid: false,
            paymentLoader: false,
            redirect: false,
            response: [],
            warunki: false
        };

        this.onNipChange = this.onNipChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onTelefonChange = this.onTelefonChange.bind(this)
    }

    componentWillMount() {
        this.setState({data: JSON.parse(sessionStorage.getItem('koszyk'))});
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        WyszukiwarkaService.getKonfigWartosc('Ile minut na oplacenie', 'Bilety')
            .then(function (response) {
                let res = response.data;
                this.setState({konfig: res})
            }.bind(this));
        this.timer = setInterval(() => this.odliczanie(), 1000)
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    odliczanie() {
        if (this.state.data !== [] && this.state.data !== '') {
            let timer = moment(sessionStorage.getItem('koszykTimer')).format('mm:ss');
            this.setState({odliczanie: timer, data: JSON.parse(sessionStorage.getItem('koszyk'))})
        }
    }

    onNipChange(e) {
        if (e.target.value.length >= 10) {
            this.setState({nipInvalid: false})
        }
        this.setState({nip: e.target.value})
    }

    onEmailChange(e) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test((e.target.value).toLowerCase())) {
            this.setState({emailInvalid: false})
        }
        this.setState({email: e.target.value})
    }

    onTelefonChange(e) {
        if (e.target.value.length <= 12 && e.target.value.length >= 9) {
            this.setState({telefonInvalid: false})
        }
        if (!isNaN(e.target.value)) {
            this.setState({telefon: e.target.value})
        }
    }

    postBilety() {
        let nip = this.state.nip;

        if (nip.length === 0) {
            nip = null;
        } else {
            nip = nip.replace(/[\ \-]/gi, '');
        }

        let idKl = 1;

        if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
            idKl = JSON.parse(sessionStorage.getItem('loggedIn')).idKl
        }

        let dicBilety = new DictionaryJS();
        let arrayPow = new DictionaryJS();

        for (let i = 0; i < this.state.data.length; i++) {

            if (this.state.data[i].idKuPrze !== null) {
                if (arrayPow.ContainsKey(this.state.data[i].idKu)) {
                    let temp = [];
                    temp = arrayPow.Get(this.state.data[i].idKu);
                    temp.push(this.state.data[i])
                } else {
                    arrayPow.Add(this.state.data[i].idKu, [this.state.data[i]]);
                }
            } else {
                if (dicBilety.ContainsKey(this.state.data[i].idKu)) {
                    let temp = [];
                    temp = dicBilety.Get(this.state.data[i].idKu);
                    temp.push(this.state.data[i])
                } else {
                    dicBilety.Add(this.state.data[i].idKu, [this.state.data[i]]);
                }
            }
        }

        let biletyArray = [];
        let biletyArrayPow = [];

        //przechodzimy przez bilety
        for (let i = 0; i < dicBilety.Count(); i++) {
            let biletyPoz = [];
            //przechodzimy przez pozycje biletow
            for (let j = 0; j < dicBilety.Get(dicBilety.GetKeys()[i]).length; j++) {
                let element = dicBilety.Get(dicBilety.GetKeys()[i])[j];
                biletyPoz.push({
                    "idKu": element.idKu,
                    "idPrDo": element.idPrDo,
                    "idPrOd": element.idPrOd,
                    "idPro": element.idPro,
                    "idTr": element.idTr,
                    "ile": 1,
                    "rodz": element.rodz,
                    "statPoz": element.statPoz,
                    "klient": element.klient
                });
            }
            let bilet = {
                "biletyPoz": biletyPoz,
                "idKl": idKl,
                "sprzedazMiejsce": "INTERNET",
                "typ": "J",
            };
            biletyArray.push(bilet)
        }

        for (let i = 0; i < arrayPow.Count(); i++) {
            let biletyPoz = [];
            let biletyPozPow = [];
            for (let j = 0; j < arrayPow.Get(arrayPow.GetKeys()[i]).length; j++) {
                let element = arrayPow.Get(arrayPow.GetKeys()[i])[j];
                biletyPoz.push({
                    "idKu": element.idKuPrze,
                    "idPrDo": element.idPrDo,
                    "idPrOd": element.idPrPrzeDo,
                    "idPro": element.idPro2,
                    "idTr": element.idTrPrze,
                    "ile": 1,
                    "rodz": element.rodz2,
                    "statPoz": element.statPoz,
                    "klient": element.klient
                });
                biletyPozPow.push({
                    "idKu": element.idKu,
                    "idPrDo": element.idPrPrzeOd,
                    "idPrOd": element.idPrOd,
                    "idPro": element.idPro,
                    "idTr": element.idTr,
                    "ile": 1,
                    "rodz": element.rodz,
                    "statPoz": element.statPoz,
                    "klient": element.klient
                });
            }
            let bilety = [{
                "biletyPoz": biletyPozPow,
                "idKl": idKl,
                "sprzedazMiejsce": "INTERNET",
                "typ": "J",
            }, {
                "biletyPoz": biletyPoz,
                "idKl": idKl,
                "sprzedazMiejsce": "INTERNET",
                "typ": "J",
            }];
            biletyArrayPow.push(bilety)
        }

        let bilety = {
            telefon: this.state.telefon,
            email: this.state.email,
            fcmToken: localStorage.getItem('fcm-token') !== null && localStorage.getItem('fcm-token') !== undefined ? JSON.parse(localStorage.getItem('fcm-token')) : null,
            nipParagon: nip,
            niepowiazane: biletyArray,
            powiazane: biletyArrayPow,
        };

        KoszykService.postBilety(bilety, idKl).then(function (response) {
            this.setState({response: response, redirect: true});
            NotificationManager.success("", "Transakcja została sfinalizowana ", 5000);
            sessionStorage.removeItem('koszyk');
            this.props.koszyk();
            this.setState({data: JSON.parse(sessionStorage.getItem('koszyk'))})
        }.bind(this)).catch(err => {
            console.log(err);
            this.setState({paymentLoader: false})
        });

    }

    postBiletyTPay() {
        let nip = this.state.nip;

        if (nip.length === 0) {
            nip = null;
        } else {
            nip = nip.replace(/[\ \-]/gi, '');
        }

        let idKl = 1;

        if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
            idKl = JSON.parse(sessionStorage.getItem('loggedIn')).idKl
        }

        let dicBilety = new DictionaryJS();
        let arrayPow = new DictionaryJS();

        for (let i = 0; i < this.state.data.length; i++) {

            if (this.state.data[i].idKuPrze !== null) {
                if (arrayPow.ContainsKey(this.state.data[i].idKu)) {
                    let temp = [];
                    temp = arrayPow.Get(this.state.data[i].idKu);
                    temp.push(this.state.data[i])
                } else {
                    arrayPow.Add(this.state.data[i].idKu, [this.state.data[i]]);
                }
            } else {
                if (dicBilety.ContainsKey(this.state.data[i].idKu)) {
                    let temp = [];
                    temp = dicBilety.Get(this.state.data[i].idKu);
                    temp.push(this.state.data[i])
                } else {
                    dicBilety.Add(this.state.data[i].idKu, [this.state.data[i]]);
                }
            }
        }

        let biletyArray = [];
        let biletyArrayPow = [];

        //przechodzimy przez bilety
        for (let i = 0; i < dicBilety.Count(); i++) {
            let biletyPoz = [];

            for (let j = 0; j < dicBilety.Get(dicBilety.GetKeys()[i]).length; j++) {
                let element = dicBilety.Get(dicBilety.GetKeys()[i])[j];
                biletyPoz.push({
                    "idKu": element.idKu,
                    "idPrDo": element.idPrDo,
                    "idPrOd": element.idPrOd,
                    "idPro": element.idPro,
                    "idTr": element.idTr,
                    "ile": 1,
                    "rodz": element.rodz,
                    "statPoz": element.statPoz,
                    "klient": element.klient
                });
            }
            let bilet = {
                "biletyPoz": biletyPoz,
                "idKl": idKl,
                "sprzedazMiejsce": "INTERNET",
                "typ": "J",
            };
            biletyArray.push(bilet)
        }

        for (let i = 0; i < arrayPow.Count(); i++) {
            let biletyPoz = [];
            let biletyPozPow = [];
            for (let j = 0; j < arrayPow.Get(arrayPow.GetKeys()[i]).length; j++) {
                let element = arrayPow.Get(arrayPow.GetKeys()[i])[j];
                biletyPoz.push({
                    "idKu": element.idKuPrze,
                    "idPrDo": element.idPrDo,
                    "idPrOd": element.idPrPrzeDo,
                    "idPro": element.idPro2,
                    "idTr": element.idTrPrze,
                    "ile": 1,
                    "rodz": element.rodz2,
                    "statPoz": element.statPoz,
                    "klient": element.klient
                });
                biletyPozPow.push({
                    "idKu": element.idKu,
                    "idPrDo": element.idPrPrzeOd,
                    "idPrOd": element.idPrOd,
                    "idPro": element.idPro,
                    "idTr": element.idTr,
                    "ile": 1,
                    "rodz": element.rodz,
                    "statPoz": element.statPoz,
                    "klient": element.klient
                });
            }
            let bilety = [{
                "biletyPoz": biletyPozPow,
                "idKl": idKl,
                "sprzedazMiejsce": "INTERNET",
                "typ": "J",
            }, {
                "biletyPoz": biletyPoz,
                "idKl": idKl,
                "sprzedazMiejsce": "INTERNET",
                "typ": "J",
            }];
            biletyArrayPow.push(bilety)
        }

        let bilety = {
            telefon: this.state.telefon,
            email: this.state.email,
            fcmToken: localStorage.getItem('fcm-token') !== null && localStorage.getItem('fcm-token') !== undefined ? JSON.parse(localStorage.getItem('fcm-token')) : null,
            nipParagon: nip,
            niepowiazane: biletyArray,
            powiazane: biletyArrayPow,
        };

        KoszykService.postBilety(bilety, idKl).then(function (response) {
            let kwota = 0;
            for (let i = 0; i < response.data.length; i++) {
                kwota = kwota + response.data[i].kwota
            }
            KoszykService.goPlatnosci(this.state.email, response.data[0].platnosciTransakcja, kwota, response.data[0].nazKl, this.state.telefon).then(function (response) {
                if (response.status === 200) {
                    sessionStorage.setItem('platnosc', response.data);
                    this.props.koszyk();
                    sessionStorage.removeItem('koszyk');
                    window.location.replace(response.data);
                }
            }.bind(this)).catch(err => {
                console.log(err);
                this.setState({paymentLoader: false})
            });
        }.bind(this)).catch(err => {
            console.log(err);
            this.setState({paymentLoader: false})
        });

    }

    handleDelete(item) {
        let array = JSON.parse(sessionStorage.getItem('koszyk'));

        for (let i = 0; i < array.length; i++) {
            if (array[i].klient === item.klient && array[i].idKu === item.idKu && array[i].data === item.data && array[i].godz === item.godz) {
                array.splice(i, 1);
            }
        }

        sessionStorage.setItem('koszyk', JSON.stringify(array));
        this.setState({data: array});
        this.props.koszyk()
    }

    validateNIP(nip) {
        nip = nip.replace(/[\ \-]/gi, '');

        let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;
        let controlNumber = parseInt(nip.substring(9, 10));
        let weightCount = weight.length;
        for (let i = 0; i < weightCount; i++) {
            sum += (parseInt(nip.substr(i, 1)) * weight[i]);
        }

        return sum % 11 === controlNumber;
    }

    goPlatnosciTPay() {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (this.state.telefon !== null && this.state.telefon.length >= 9 && this.state.telefon.length <= 12) {
            if (this.state.email !== null && this.state.email.length > 3 && re.test((this.state.email).toLowerCase())) {
                if (this.state.nip === '' || this.validateNIP(this.state.nip)) {
                    if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
                        this.setState({paymentLoader: true});
                        this.postBiletyTPay()
                    } else {
                        if (this.state.warunki) {
                            this.setState({emailInvalid: false, paymentLoader: true});
                            this.postBiletyTPay();
                        } else {
                            NotificationManager.error("", "Aby kupić bilet musisz zaakceptować warunki ", 5000);
                        }
                    }
                } else {
                    this.setState({nipInvalid: true})
                }
            } else {
                this.setState({emailInvalid: true})
            }
        } else {
            this.setState({telefonInvalid: true})
        }
    }

    goPlatnosci() {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


        if (re.test((this.state.email).toLowerCase())) {
            if (this.state.nip === '' || this.validateNIP(this.state.nip)) {
                if (sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined) {
                    this.setState({paymentLoader: true});
                    this.postBilety()
                } else {
                    if (this.state.warunki) {
                        this.setState({emailInvalid: false, paymentLoader: true});
                        this.postBilety();
                    } else {
                        NotificationManager.error("", "Aby kupić bilet musisz zaakceptować warunki ", 5000);
                    }
                }
            } else {
                this.setState({nipInvalid: true})
            }
        } else {
            this.setState({emailInvalid: true})
        }

    }

    iloscBiletow() {
        let koszyk = JSON.parse(sessionStorage.getItem('koszyk'));

        let ilosc = 0;

        for (let i = 0; i < koszyk.length; i++) {
            if (koszyk[i].idKuPrze !== null) {
                ilosc = ilosc + 2
            } else {
                ilosc++
            }
        }

        return ilosc;
    }

    getPodsumowanie() {
        let koszyk = JSON.parse(sessionStorage.getItem('koszyk'));

        let cena = 0;

        for (let i = 0; i < koszyk.length; i++) {
            if (koszyk[i].idKuPrze !== null) {
                cena = cena + koszyk[i].cena + koszyk[i].cena2
            } else {
                cena = cena + koszyk[i].cena
            }
        }

        return cena;
    }

    getCzasOczekiwania(item) {
        let wynikGodz = moment(moment(item.godzPrze, 'H:mm').diff(moment(item.godzPrzyPrze, 'H:mm'))).format('HH');
        let wynikMin = moment(moment(item.godzPrze, 'H:mm').diff(moment(item.godzPrzyPrze, 'H:mm'))).format('mm');
        let iloscMin = wynikMin;
        wynikMin = item.czasOczek;
        let minuty = 'minut';

        if (wynikMin === 1) {
            minuty = 'minuta'
        }
        //
        // let lastDigit = wynikMin.toString().split('').pop()
        //
        // if (lastDigit === "2" || lastDigit === "3" || lastDigit === "4") {
        //     minuty = 'minuty'
        // }

        return <span><i
            className="fa fa-arrows-v"/> Czas oczekiwania: {parseInt(wynikGodz) - 1} godz. {parseInt(iloscMin)} min</span>
    }

    render() {
        return <div className="home">

            {this.state.redirect ? <Realizacja email={this.state.email} bilety={this.state.response.data}/> :
                <div className="container">
                    <hr/>
                    <div>{JSON.parse(sessionStorage.getItem('koszyk')) !== undefined && JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')).length !== 0
                        ?
                        <div className="row">
                            <div className="col-sm-9">
                                <div className="row">
                                    <div className="col-sm-4"><h4>Koszyk:</h4></div>
                                    <div className="col-sm-4 text-center">
                                        <h4>
                                            <div className="rezerwacja">Ilość
                                                biletów: <span>{this.iloscBiletow()}</span>
                                            </div>
                                        </h4>
                                    </div>
                                    <div className="col-sm-4 text-right">
                                        <h4>{JSON.parse(sessionStorage.getItem('koszyk'))[0].statPoz !== -1 ?
                                            <div className="rezerwacja">Typ: <span>Rezerwacja</span></div> :
                                            <div className="zakup">Typ: <span>Zakup</span></div>}</h4></div>
                                </div>
                                {this.state.data.map((item, index) => {
                                    return (
                                        <div>
                                            {item.idKuPrze !== null ?
                                                <div>
                                                    <div
                                                        className={"wynik"}>
                                                        <p style={{marginBottom: 5}}><i
                                                            className='fa fa-times'
                                                            style={{
                                                                float: 'right',
                                                                paddingRight: 5,
                                                                color: 'red',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => this.handleDelete(item)}> </i></p>
                                                        <div key={"kurs" + item.idKu}
                                                             style={{marginLeft: 5, marginRight: 5}}
                                                             className={"row"}>
                                                            <div className="col-xs-1"
                                                                 style={{
                                                                     textAlign: 'right',
                                                                     paddingLeft: 0,
                                                                     paddingRight: 0
                                                                 }}>
                                                                <div className="godzinaOdjazd">{item.godz} <i
                                                                    className="fa fa-arrow-right"
                                                                    style={{fontSize: 13}}> </i>
                                                                </div>
                                                                <div className="godzinaPrzyjazd">{item.godzPrzyPrze} <i
                                                                    className="fa fa-arrow-left"
                                                                    style={{fontSize: 13}}> </i></div>
                                                            </div>
                                                            <div className="col-sm-5 miejscowosciKoszykMobilka"
                                                                 style={{paddingLeft: 15, paddingRight: 5}}>
                                                                <div className="miejsceOdjazd">{item.nazMiOd}
                                                                    <span> {item.nazPrOd}</span></div>
                                                                <div className="miejscePrzyjazd">{item.nazMiPrze}
                                                                    <span> {item.nazPrPrzeOd}</span></div>
                                                            </div>
                                                            <div className="col-sm-4 waznyKlientMobilka"
                                                                 style={{textAlign: 'left'}}>
                                                                <div
                                                                    className="czas">Ważny: <b>{item.data.substr(0, 10)}</b>
                                                                </div>
                                                                <div
                                                                    className="czas">Klient: <b>{item.klient}</b></div>
                                                            </div>
                                                            <div className="col-sm-2 typCenaMobilka"
                                                                 style={{
                                                                     paddingLeft: 0,
                                                                     paddingRight: 0,
                                                                     textAlign: 'left'
                                                                 }}>
                                                                <div className="czas">Typ: <b>{item.rodzaj}</b></div>
                                                                <div
                                                                    className="cenaNormalny"
                                                                    style={{marginTop: 5}}>Cena: <span>{acc.formatMoney(item.cena, {
                                                                    symbol: "zł",
                                                                    format: "%v %s"
                                                                })}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12 text-center" style={{
                                                            fontSize: '0.875rem',
                                                            color: '#858585',
                                                            marginTop: 10,
                                                            marginBottom: 5
                                                        }}>
                                                            {this.getCzasOczekiwania(item)}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={"wynik"}>
                                                        <div key={"kurs" + item.idKu}
                                                             style={{marginLeft: 5, marginRight: 5}}
                                                             className={"row"}>
                                                            <div className="col-xs-1"
                                                                 style={{
                                                                     textAlign: 'right',
                                                                     paddingLeft: 0,
                                                                     paddingRight: 0
                                                                 }}>
                                                                <div className="godzinaOdjazd">{item.godzPrze} <i
                                                                    className="fa fa-arrow-right"
                                                                    style={{fontSize: 13}}> </i>
                                                                </div>

                                                                <div className="godzinaPrzyjazd">{item.godzPrzy} <i
                                                                    className="fa fa-arrow-left"
                                                                    style={{fontSize: 13}}> </i></div>
                                                            </div>
                                                            <div className="col-sm-5 miejscowosciKoszykMobilka"
                                                                 style={{paddingLeft: 15, paddingRight: 5}}>
                                                                <div className="miejsceOdjazd">{item.nazMiPrze}
                                                                    <span> {item.nazPrPrzeDo}</span></div>
                                                                <div className="miejscePrzyjazd">{item.nazMiDo}
                                                                    <span> {item.nazPrDo}</span></div>
                                                            </div>
                                                            <div className="col-sm-4 waznyKlientMobilka"
                                                                 style={{textAlign: 'left'}}>
                                                                <div
                                                                    className="czas">Ważny: <b>{item.dataOdjPrze.substr(0, 10)}</b>
                                                                </div>
                                                                <div
                                                                    className="czas">Klient: <b>{item.klient}</b></div>
                                                            </div>
                                                            <div className="col-sm-2 typCenaMobilka"
                                                                 style={{
                                                                     paddingLeft: 0,
                                                                     paddingRight: 0,
                                                                     textAlign: 'left'
                                                                 }}>
                                                                <div className="czas">Typ: <b>{item.rodzaj2}</b></div>
                                                                <div
                                                                    className="cenaNormalny"
                                                                    style={{marginTop: 5}}>Cena: <span>{acc.formatMoney(item.cena2, {
                                                                    symbol: "zł",
                                                                    format: "%v %s"
                                                                })}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                </div>
                                                :
                                                <div>
                                                    <div
                                                        className={"wynik"}>
                                                        <p style={{marginBottom: 5}}><i
                                                            className='fa fa-times'
                                                            style={{
                                                                float: 'right',
                                                                paddingRight: 5,
                                                                color: 'red',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => this.handleDelete(item)}> </i></p>
                                                        <div key={"kurs" + item.idKu}
                                                             style={{marginLeft: 5, marginRight: 5}}
                                                             className={"row"}>
                                                            <div className="col-xs-1"
                                                                 style={{
                                                                     textAlign: 'right',
                                                                     paddingLeft: 0,
                                                                     paddingRight: 0
                                                                 }}>
                                                                <div className="godzinaOdjazd">{item.godz} <i
                                                                    className="fa fa-arrow-right"
                                                                    style={{fontSize: 13}}> </i>
                                                                </div>
                                                                <TopIf isTrue={item.idTrPrze !== null}>
                                                                    <div
                                                                        className="godzinaPrzesiadka">{item.godzPrzyPrze}
                                                                        <i
                                                                            className="fa fa-arrow-left"
                                                                            style={{fontSize: 13}}> </i>
                                                                    </div>
                                                                    <div className="godzinaPrzesiadka">{item.godzPrze}
                                                                        <i
                                                                            className="fa fa-arrow-right"
                                                                            style={{fontSize: 13}}> </i>
                                                                    </div>
                                                                </TopIf>
                                                                <div className="godzinaPrzyjazd">{item.godzPrzy} <i
                                                                    className="fa fa-arrow-left"
                                                                    style={{fontSize: 13}}> </i></div>
                                                            </div>
                                                            <div className="col-sm-5 miejscowosciKoszykMobilka"
                                                                 style={{paddingLeft: 15, paddingRight: 5}}>
                                                                <div className="miejsceOdjazd">{item.nazMiOd}
                                                                    <span> {item.nazPrOd}</span></div>
                                                                <TopIf isTrue={item.idTrPrze !== null}>
                                                                    <div
                                                                        className="miejscePrzesiadka">{item.nazMiPrze}
                                                                        <span> {item.nazPrPrzeOd}</span></div>
                                                                    <div
                                                                        className="miejscePrzesiadka">{item.nazMiPrze}
                                                                        <span> {item.nazPrPrzeDo}</span></div>
                                                                </TopIf>
                                                                <div className="miejscePrzyjazd">{item.nazMiDo}
                                                                    <span> {item.nazPrDo}</span></div>
                                                            </div>
                                                            <div className="col-sm-4 waznyKlientMobilka"
                                                                 style={{textAlign: 'left'}}>
                                                                {item.idTrPrze !== null ? <div>&nbsp;</div> : null}
                                                                <div
                                                                    className="czas">Ważny: <b>{item.data.substr(0, 10)}</b>
                                                                </div>
                                                                <div
                                                                    className="czas">Klient: <b>{item.klient}</b></div>
                                                            </div>
                                                            <div className="col-sm-2 typCenaMobilka"
                                                                 style={{
                                                                     paddingLeft: 0,
                                                                     paddingRight: 0,
                                                                     textAlign: 'left'
                                                                 }}>
                                                                {item.idTrPrze !== null ? <div>&nbsp;</div> : null}
                                                                <div className="czas">Typ: <b>{item.rodzaj}</b></div>
                                                                <div
                                                                    className="cenaNormalny"
                                                                    style={{marginTop: 5}}>Cena: <span>{acc.formatMoney(item.cena, {
                                                                    symbol: "zł",
                                                                    format: "%v %s"
                                                                })}</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                </div>}
                                        </div>
                                    )
                                })}
                                <div className="text-left" style={{fontSize: '0.75rem'}}>
                                    Należy zrealizować koszyk w ciągu: <font
                                    style={{color: 'red'}}>{this.state.odliczanie}</font>, w przeciwnym razie koszyk
                                    zostanie wyczyszczony.
                                </div>
                                <div className="text-right font-weight-bold"
                                     style={{paddingTop: 10}}>Podsumowanie: <font
                                    color="#57b13c"> {acc.formatMoney(this.getPodsumowanie(), {
                                    symbol: 'zł',
                                    format: '%v %s'
                                })}</font></div>
                            </div>
                            <div className="col-sm-3" style={{borderLeft: '1px solid #0000001a'}}>
                                <h4>Dane:</h4>
                                <p><input type='text' value={this.state.email} placeholder={'Adres e-mail'}
                                          onChange={this.onEmailChange} className='form-control'/></p>
                                {this.state.emailInvalid ?
                                    <div className="niepoprawneDaneBilety" style={{fontSize: 15}}>Proszę podać poprawny
                                        adres e-mail.</div> : null}
                                <p><input type='text' value={this.state.telefon} placeholder={"Numer telefonu"}
                                          onChange={this.onTelefonChange}
                                          className='form-control'/>
                                </p>
                                {this.state.telefonInvalid ?
                                    <div className="niepoprawneDaneBilety" style={{fontSize: 15}}>Proszę podać poprawny
                                        numer telefonu.</div> : null}
                                {sessionStorage.getItem('loggedIn') !== null && sessionStorage.getItem('loggedIn') !== undefined ? null :
                                    <div style={{fontSize: '0.875rem'}}>
                                        <Zgody war2={true} warunki={this.state.warunki}
                                               setWarunki={() => this.setState({warunki: !this.state.warunki})}/>
                                    </div>}
                                <div className="inputZgodyDiv" style={{fontSize: '0.875rem', marginBottom: 10}}>
                                    <input type="checkbox" checked={this.state.nipCheck}
                                           onChange={() => this.setState({
                                               nipCheck: !this.state.nipCheck,
                                               nip: '',
                                               nipInvalid: false
                                           })}/> NIP dla faktury VAT (dla późniejszej zamiany paragonu na fakturę)
                                </div>
                                {this.state.nipCheck ?
                                    <div><p className={'nipInput'}><input type='number' value={this.state.nip}
                                                                          placeholder={'Numer NIP'}
                                                                          onChange={this.onNipChange}
                                                                          className='form-control'/></p>
                                        {this.state.nipInvalid ?
                                            <div className="niepoprawneDaneBilety" style={{fontSize: 15}}>Proszę podać
                                                poprawny
                                                numer NIP.</div> : null}</div> : null}
                                <div className="text-center">
                                    {JSON.parse(sessionStorage.getItem('koszyk'))[0].statPoz !== -1 ?
                                        <Button bsStyle="info" disabled={this.state.paymentLoader}
                                                onClick={() => this.goPlatnosci()}>Rezerwuj</Button> :
                                        <Button bsStyle="success" disabled={this.state.paymentLoader}
                                                onClick={() => this.goPlatnosciTPay()}>Przejdź
                                            do płatności</Button>}
                                    {this.state.paymentLoader ? <div className="loaderDim" style={{marginTop: 5}}><i
                                        className="fa fa-spinner fa-pulse fa-fw"
                                        style={{
                                            color: '#58b13d'
                                        }}> </i></div> : null}
                                </div>
                                <hr/>
                                {JSON.parse(sessionStorage.getItem('koszyk'))[0].statPoz !== -1 ?
                                    <div>
                                        <div style={{fontSize: '0.875rem', textAlign: 'center'}}>Koszyk zawiera pozycje
                                            do zarezerwowania.
                                            Zarezerwowane pozycje powinny zostać opłacone u kierowcy do <font
                                                color={'red'}>15 minut </font>przed odjazdem kursu.
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div style={{fontSize: '0.875rem', textAlign: 'center'}}>Po przejściu do
                                            płatności należy opłacić bilety w ciągu <font
                                                color={'red'}>{this.state.konfig} minut.</font> W przeciwnym wypadku
                                            bilety zostaną anulowane.
                                        </div>
                                    </div>
                                }
                            </div>

                        </div> :
                        <div className="row">
                            <div className="col-sm-12 text-center wynik"
                                 style={{paddingTop: 50, marginTop: 15, marginBottom: 15, paddingBottom: 50}}>
                                <h2>Koszyk jest pusty</h2>
                                <div>Użyj <Link style={{color: '#53a53c'}} to={'/'}>wyszukiwarki połączeń</Link> by
                                    dodać bilety do koszyka.
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>}
            <div className="container">
                <hr/>
            </div>
            <Footer/>

        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/finalizacja/Finalizacja.js